import { Inject } from '@odinjs/odin';
import { TextAPI } from '@philips-internal/oswald-ui-components';
import Controller, { OnMount } from '@philips-internal/oswald-ui-core/lib/client';
import { MessageService } from '@philips-internal/oswald-ui-core/lib/services';
import { FragmentNames, ScoreReferenceAliases } from '../../../codegen/index';
import BaseController from '../../BaseController';
import { ScoreListContext } from '../scores-list/scores-list-service';

export enum ScoreType {
  SCORE_TISS_28 = '12',
  SCORE_NAS     = '24',
  SCORE_DINI    = '30',
  SCORE_NRS     = '48',
  SCORE_MEWS    = '82',
  SCORE_MORSE   = '89',
  SCORE_PEWS    = '140',
  SCORE_FLEX    = '142'
}

enum ScoreReference {
  REFERENCE_DINI    = 'tws.reference-dini-score',
  REFERENCE_PEWS    = 'tws.reference-pews-score',
  REFERENCE_MEWS    = 'tws.reference-mews-score',
  REFERENCE_TISS_28 = 'tws.reference-tiss-28-score',
  REFERENCE_NAS     = 'tws.reference-nas',
  REFERENCE_MORSE   = 'tws.reference-morse',
  REFERENCE_NRS     = 'tws.reference-nrs'
}

@Controller ({ fragment: FragmentNames.SCORE_REFERENCE })
export default class ScoreReferenceController extends BaseController {

  @Inject(ScoreReferenceAliases.TEXT_REFERENCE)
  textReferenceAPI!: TextAPI;

  @OnMount({ target: ScoreReferenceAliases.FORM_SCORE_REFERENCE })
  handleMount(): void {
    const tab = ScoreListContext.currentTab;
    switch (tab) {
      case ScoreType.SCORE_DINI:
        return this.textReferenceAPI.setValue(MessageService.translate(ScoreReference.REFERENCE_DINI));
      case ScoreType.SCORE_PEWS:
        return this.textReferenceAPI.setValue(MessageService.translate(ScoreReference.REFERENCE_PEWS));
      case ScoreType.SCORE_MEWS:
        return this.textReferenceAPI.setValue(MessageService.translate(ScoreReference.REFERENCE_MEWS));
      case ScoreType.SCORE_TISS_28:
        return this.textReferenceAPI.setValue(MessageService.translate(ScoreReference.REFERENCE_TISS_28));
      case ScoreType.SCORE_NAS:
        return this.textReferenceAPI.setValue(MessageService.translate(ScoreReference.REFERENCE_NAS));
      case ScoreType.SCORE_MORSE:
        return this.textReferenceAPI.setValue(MessageService.translate(ScoreReference.REFERENCE_MORSE));
      case ScoreType.SCORE_NRS:
        return this.textReferenceAPI.setValue(MessageService.translate(ScoreReference.REFERENCE_NRS));
      default:
        return this.textReferenceAPI.setValue(MessageService.translate('text.no-record'));
    }
  }
}